// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"90":"index_db","576":"m_main","599":"p_main"}[chunkId] || chunkId) + "." + {"90":"ef5c12d3","576":"2adef3a7","599":"356a6794","601":"5656c8fa","737":"1aaee3a0","821":"c471b2be"}[chunkId] + ".chunk.js";
};